<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-finance</v-icon>
            Financial Management
          </v-card-title>

          <v-card-text>
            <v-tabs
              v-model="activeTab"
              background-color="grey lighten-4"
              color="primary"
            >
              <v-tab>
                <v-icon left>mdi-tag</v-icon>
                Categories
              </v-tab>
              <v-tab>
                <v-icon left>mdi-cash-plus</v-icon>
                Income
              </v-tab>
              <v-tab>
                <v-icon left>mdi-car</v-icon>
                Mileage
              </v-tab>
              <v-tab>
                <v-icon left>mdi-cash-minus</v-icon>
                Expenses
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab">
              <!-- Categories Tab -->
              <v-tab-item>
                <CategoryForm @success="handleSuccess" @error="handleError" />
              </v-tab-item>

              <!-- Income Tab -->
              <v-tab-item>
                <IncomeForm @success="handleSuccess" @error="handleError" />
              </v-tab-item>

              <!-- Mileage Tab -->
              <v-tab-item>
                <MileageForm @success="handleSuccess" @error="handleError" />
              </v-tab-item>

              <!-- Expenses Tab -->
              <v-tab-item>
                <ExpenseForm @success="handleSuccess" @error="handleError" />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Success/Error Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="4000"
      top
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import CategoryForm from "@/components/FinancialManagement/CategoryForm.vue";
import IncomeForm from "@/components/FinancialManagement/IncomeForm.vue";
import MileageForm from "@/components/FinancialManagement/MileageForm.vue";
import ExpenseForm from "@/components/FinancialManagement/ExpenseForm.vue";

export default {
  name: "FinancialManagement",

  components: {
    CategoryForm,
    IncomeForm,
    MileageForm,
    ExpenseForm,
  },

  data() {
    return {
      activeTab: 0,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },

  methods: {
    handleSuccess(message) {
      this.showSnackbar(message, "success");
    },

    handleError(message) {
      this.showSnackbar(message, "error");
    },

    showSnackbar(message, color = "success") {
      this.snackbar = {
        show: true,
        message,
        color,
      };
    },
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}

.v-tab {
  text-transform: none !important;
}
</style>
